import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import ListarDatos from "../../general/ListarDatos";
import { BtnEditar } from "../../general/BotonesAccion";
import BotonAtras from "../components/BotonAtras";
import BtnAdministrar from "../components/BtnAdministrar";
import { Cargando } from "../components/Estados";
import ModalHorario from "./ModalHorario";
import ModalAuxiliaresHorario from "./ModalAuxiliaresHorario";
import {
  asignarDiasEnHorario,
  crearHorario,
  editarHorario,
  obtenerHorarios,
  retirarHorario,
} from "../services/bibliotecaApi";
import { describirDias } from "../model/horarios";

/**
 * "3 personas asignadas". Los nombres se ven en la tuerca; en la lista solo
 * va cuantas son.
 */
const resumenAuxiliares = ({ auxiliares }) => {
  if (auxiliares.length === 0) return "Sin personas asignadas";
  return auxiliares.length === 1
    ? "1 persona asignada"
    : `${auxiliares.length} personas asignadas`;
};

/**
 * Horarios de biblioteca (los turnos de AGIL), en lista: el lapiz edita las
 * horas y la tuerca administra quien trabaja en cada uno y que dias (el
 * horario es solo la franja; los dias son de cada persona). A una persona
 * solo se le asignan solicitudes cuyo dia y hora caen dentro de alguno de sus
 * horarios, y no puede tener dos horarios que se crucen el mismo dia.
 *
 * Todas las acciones responden los horarios actualizados, y la pantalla se
 * repinta con eso.
 */
const HorariosGestion = ({ onMensaje, volver }) => {
  const [datos, setDatos] = useState(null);
  // null: cerrado; {}: nuevo; un horario: editarlo.
  const [editando, setEditando] = useState(null);
  const [administrando, setAdministrando] = useState(null);

  const cargar = () =>
    obtenerHorarios()
      .then(setDatos)
      .catch((fallo) => onMensaje(fallo.message, "info"));

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const aplicar = async (peticion, exito) => {
    const { ok, titulo, datos: nuevos } = await peticion;
    onMensaje(ok ? exito : titulo, ok ? "success" : "info");
    if (ok) setDatos(nuevos);
    return ok;
  };

  const cerrarEdicion = async (peticion, exito) => {
    const ok = await aplicar(peticion, exito);
    if (ok) setEditando(null);
    return ok;
  };

  if (!datos) return <Cargando />;

  // El modal de la tuerca lee el horario de `datos`, asi refleja cada cambio.
  const horarioAdministrado = datos.horarios.find(({ id }) => id === administrando);

  return (
    <div>
      <BotonAtras onClick={volver} />
      <ListarDatos
        id="tbl_biblioteca_horarios"
        datos={datos.horarios}
        titulo="Horarios de biblioteca"
        opciones
        buscar
        refrescar
        actRefrescar={cargar}
        agregar
        actAgregar={() => setEditando({})}
        mensajeVacio="Aún no hay horarios. Crea el primero con el botón +."
        avatar={({ hora_entrada }) => hora_entrada.slice(0, 2)}
        fila_principal={({ hora_entrada, hora_salida }) => `${hora_entrada} a ${hora_salida}`}
        filas={[{ id: "auxiliares", mostrar: resumenAuxiliares }]}
        acciones={(horario) => (
          <div>
            <BtnEditar callback={() => setEditando(horario)} />
            <BtnAdministrar texto="Auxiliares" callback={() => setAdministrando(horario.id)} />
          </div>
        )}
      />

      {editando && (
        <ModalHorario
          horario={editando.id ? editando : null}
          onCerrar={() => setEditando(null)}
          onGuardar={(entrada, salida) =>
            editando.id
              ? cerrarEdicion(editarHorario(editando.id, entrada, salida), "Horario actualizado.")
              : cerrarEdicion(crearHorario(entrada, salida), "Horario creado.")
          }
          onRetirar={() => cerrarEdicion(retirarHorario(editando.id), "Horario retirado.")}
        />
      )}

      {horarioAdministrado && (
        <ModalAuxiliaresHorario
          horario={horarioAdministrado}
          personas={datos.personas}
          onCerrar={() => setAdministrando(null)}
          onCambiarDias={(persona, dias) =>
            aplicar(
              asignarDiasEnHorario(administrando, persona.id, dias),
              dias.length
                ? `${persona.nombre}: ${describirDias(dias).toLowerCase()}.`
                : `${persona.nombre} salió del horario.`,
            )
          }
        />
      )}
    </div>
  );
};

HorariosGestion.propTypes = {
  onMensaje: PropTypes.func.isRequired,
  volver: PropTypes.func.isRequired,
};

export default HorariosGestion;
